import React from 'react';

const FLAG_CDN_BASE = 'https://cdn.timum.de/bookingjs/flags';

export const getTelInputFlagElement = (isoCode, { imgProps, countryName }) => (
  <img
    {...imgProps}
    src={`${FLAG_CDN_BASE}/w40/${isoCode.toLowerCase()}.webp`}
    alt={countryName}
  />
);
